import { Injectable } from '@angular/core';
import {AbstractControl, ValidationErrors} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorService {

  constructor() { }

  matchPasswordValidator(controlName: string, matchingControlName: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      const input = control.get(controlName);
      const compareControl = control.get(matchingControlName);

      if (compareControl.errors && !compareControl.errors.mustMatch) {
        return null;
      }
      // set error on matchingControl if validation fails
      if (input.value !== compareControl.value) {
        compareControl.setErrors({ mustMatch: true });
        return ({ mustMatch: true });
      } else {
        compareControl.setErrors(null);
        return null;
      }
    };
  }

  passwordPatternValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = new RegExp('^(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])(?=.*[^\\w\\d]).*$');
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }

  compareTimes(controlName: string, matchingControlName: string) {
    return (control: AbstractControl): ValidationErrors | null => {

      const input = control.get(controlName);
      const compareControl = control.get(matchingControlName);

      if (compareControl.errors && !compareControl.errors.greaterThan) {
        return null;
      }

      // set error on matchingControl if validation fails
      if (parseFloat(input.value) >= parseFloat(compareControl.value)) {
        compareControl.setErrors({ greaterThan: true });
        return ({greaterThan: true});

      } else {
        compareControl.setErrors(null);
        return null;
      }
    };
  }

  compareDates(controlName: string, compareControlName: string) {
    return (control: AbstractControl): ValidationErrors | null => {

      const input = control.get(controlName);
      const compareControl = control.get(compareControlName);

      if (compareControl.errors && !compareControl.errors.greaterThan) {
        return null;
      }

      if (compareControl.value === null){
        compareControl.setErrors(null);
        return null;
      }

      const startDate = new Date(input.value);
      const endDate = new Date(compareControl.value);

      // set error on matchingControl if validation fails
      if (startDate > endDate) {
        compareControl.setErrors({ greaterThan: true });
        return ({greaterThan: true});

      } else {
        compareControl.setErrors(null);
        return null;
      }
    };
  }

  bankNameValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = /^[a-z ,.\'-]+$/i;
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }
  bankHolderNameValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = /^[a-z0-9 ,.\'-]+$/i;
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }
  bankBSBValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = /^\d{3}-?\d{3}$/;
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }
  bankAccountValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = /^\d{6,9}$/;
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }
  mobilePatternValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const phone = control.value.trim();
      const filteredPhone = phone.replace(/\s+/g, '');
      const regex = /^04\d{8}$/;
      const valid = regex.test(filteredPhone);
      return valid ? null : { pattern: true };
    };
  }

  workPhoneValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const filteredPhone = control.value.trim().replace(/\s+/g, '');
      const regex = /^(\d{3})(\d{4})(\d{3})$/;
      const valid = regex.test(filteredPhone);
      return valid ? null : { pattern: true };
    }; 
  }

  onlySpacesValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      return control.value.trim().length > 0 ? null : { empty: true }; 
      return control.value.trim().length > 0 ? null : { empty: true }; 
    };
  }

  addressValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = /^[a-z0-9 \/,.\'-]+$/i;
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }

  suburbValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = /^[a-z0-9 ,.\'-]+$/i;
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }

  stateValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const states = ['NSW', 'VIC', 'SA', 'WA', 'QLD', 'ACT', 'NT', 'TAS'];
      const valid = states.includes(control.value);
      return valid ? null : { pattern: true };
    };
  }

  postcodeValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const regex = /\b\d{3,4}\b/;
      const valid = regex.test(control.value);
      return valid ? null : { pattern: true };
    };
  }

  technicianPhonePatternValidator() {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const phone = control.value.trim();
      const filteredPhone = phone.replace(/\s+/g, '');
      const regex = /^0[1-9][0-9]{8}$/;
      const valid = regex.test(filteredPhone);
      return valid ? null : { pattern: true };
    };
  }
}
